import React from "react";
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Alert,
    AlertTitle,
} from "@mui/material";

const Dialogbox = ({ open, onClose, title, severity, message, onConfirm, confirmText = "Confirm", closeText = "Close" }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ bgcolor: "grey.100" }}>
                    <Alert
                        severity={severity}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <AlertTitle>{title}</AlertTitle>
                        {message}
                    </Alert>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{closeText}</Button>
                {onConfirm && (
                    <Button onClick={onConfirm} autoFocus>
                        {confirmText}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default Dialogbox;
